export const SPLRecommendation = ({recommendation}) => {
   if (recommendation.current == null) {
      return (
         <React.Fragment>
            <p>
               For example, if the current value is <code>pg_stat_statements</code>,
               you can set the new value to <code>pg_stat_statements, auto_explain</code>:
            </p>
            <CodeBlock>
               ALTER SYSTEM SET shared_preload_libraries TO pg_stat_statements, auto_explain;
            </CodeBlock>
         </React.Fragment>
      )
   }
   return (
      <React.Fragment>
         <p>
            The current value appears to be <code>{recommendation.current}</code>.
            You can confirm this by running
         </p>
         <CodeBlock>
            SHOW shared_preload_libraries;
         </CodeBlock>
         <p>
            and then set the new value:
         </p>
         <CodeBlock>
            ALTER SYSTEM SET shared_preload_libraries TO {recommendation.recommended};
         </CodeBlock>
      </React.Fragment>
   )
}

To enable `auto_explain`, you will need to add the auto_explain module to the `shared_preload_libraries`
configuration setting.

<SPLRecommendation recommendation={props.splRecommendation} />

Since changes to `shared_preload_libraries` only take effect at server start, after you apply
these settings, you will need to restart Postgres:

<CodeBlock language="bash">
{`sudo systemctl restart postgresql`}
</CodeBlock>

After the reboot completes, verify that `shared_preload_libraries` now includes `auto_explain`
and that the setting change does not require a restart (`pending_restart` should be `f`):

<CodeBlock language="sql">
{`SELECT setting, pending_restart FROM pg_settings WHERE name = 'shared_preload_libraries';`}
</CodeBlock>

If `auto_explain` is enabled and no longer requires a restart, you can proceed to
review our recommended `auto_explain` configuration settings:
